// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Joystick = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <circle fill={fill} cx='24' cy='24' r='22.4' />
      <polyline fill='none' points='30 36 24 42 18 36' />
      <polyline fill='none' points='18 12 24 6 30 12' />
      <polyline fill='none' points='12 30 6 24 12 18' />
      <polyline fill='none' points='36 18 42 24 36 30' />
      <circle fill='none' cx='24' cy='24' r='8.2' />
    </svg>
  );
};
